import { Check } from "lucide-react";
import { formatCurrency } from "common/utils/format/number";
import { PreCutInfoTooltip } from "./PreCutInfoTooltip";

interface SaveOptionsSectionProps {
  preCutPrice: number;
  isEnabled?: boolean;
  onToggle?: ((enabled: boolean) => void) | undefined;
}

export function SaveOptionsSection({
  preCutPrice,
  isEnabled = false,
  onToggle
}: SaveOptionsSectionProps) {
  return (
    <div className="flex flex-col gap-1 rounded-lg bg-indigo-50 p-2">
      {/* First line: Title with info icon */}
      <div className="flex items-center gap-2">
        <span className="whitespace-nowrap text-base font-bold text-gray-900">Want save time?</span>
        <PreCutInfoTooltip />
      </div>

      {/* Second line: Pre-cut option */}
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onToggle?.(!isEnabled)}
          className="flex size-6 items-center justify-center rounded bg-gray-900 transition-opacity hover:opacity-80"
          data-testid="pre-cut-checkbox"
        >
          {isEnabled && <Check className="size-3 text-white" strokeWidth={3} />}
        </button>

        <span className="whitespace-nowrap text-sm font-bold text-gray-800">
          Pre-cut transfers ({formatCurrency(preCutPrice)} each)
        </span>
      </div>
    </div>
  );
}
